import createSvgIcon from '@mui/icons-material/utils/createSvgIcon'
import React from 'react'
// viewBox="0 0 20 20"

const ReturnIcon = createSvgIcon(
  <>
    <path
      xmlns='http://www.w3.org/2000/svg'
      className='st0'
      d='M10,13l1.1-1.1l-1.2-1.2H13V9.2H9.9l1.2-1.2L10,7l-3,3L10,13z M4.5,17c-0.4,0-0.8-0.1-1.1-0.4  C3.1,16.3,3,15.9,3,15.5v-11c0-0.4,0.1-0.8,0.4-1.1C3.7,3.1,4.1,3,4.5,3h3.6c0.1-0.4,0.3-0.8,0.7-1.1S9.5,1.5,10,1.5  c0.5,0,0.9,0.1,1.2,0.4c0.4,0.3,0.6,0.6,0.7,1.1h3.6c0.4,0,0.8,0.1,1.1,0.4C16.9,3.7,17,4.1,17,4.5v11c0,0.4-0.1,0.8-0.4,1.1  c-0.3,0.3-0.6,0.4-1.1,0.4H4.5z M4.5,15.5h11v-11h-11V15.5z M10,4c0.1,0,0.3,0,0.4-0.1s0.1-0.2,0.1-0.4s0-0.3-0.1-0.4S10.1,3,10,3  C9.9,3,9.7,3,9.6,3.1C9.5,3.2,9.5,3.4,9.5,3.5s0,0.3,0.1,0.4C9.7,4,9.9,4,10,4z M4.5,15.5v-11V15.5z'
    />
  </>,
  'ReturnIcon'
)

export default ReturnIcon
